import { optionalCostList } from "constants/global";
import React from "react";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";

const PaymentTab = ({ shipmentDetails }) => {
    const paymentDetails = Object.entries(shipmentDetails?.paymentDetails ?? {})?.filter(item => item?.[1] > 0).map(item => {
        const data = optionalCostList.find(costType => costType.value == item?.[0])
         return !data
             ? {
                   costType: item?.[0],
                   amount: item?.[1],
               }
             : {
                   costType: data?.label,
                   amount: item?.[1],
               };
    });
    return (
        <>
            {/* Split Payment Section */}
            {shipmentDetails?.paymentTerm === "SplitPayment" && (
                <div className="p-4 border rounded-lg">
                    <div className="flex items-center justify-between mb-4">
                        <p className="text-sm font-medium text-main-dark">
                            Split payment ({shipmentDetails?.paymentOne}-
                            {shipmentDetails?.paymentTwo})
                        </p>
                        <p className="text-sm text-main-grey">
                            {(
                                (shipmentDetails?.paidAmount / shipmentDetails?.totalAmount) *
                                100
                            ).toFixed(0)}
                            % complete
                        </p>
                    </div>
                    <div className="w-full h-2 mb-2 bg-gray-200 rounded-full">
                        <div
                            className="h-2 bg-green-600 rounded-full"
                            style={{
                                width: `${
                                    (shipmentDetails?.paidAmount / shipmentDetails?.totalAmount) *
                                    100
                                }%`,
                            }}
                        />
                    </div>
                    <p className="text-sm text-main-grey">
                        {formatMoney(shipmentDetails?.paidAmount)} /{" "}
                        {formatMoney(shipmentDetails?.totalAmount)}
                    </p>
                </div>
            )}

            <div className="grid grid-cols-2 gap-4 p-4 border border-gray-200">
                <div>
                    <p className="mb-1 text-sm text-main-grey">Next payment due</p>
                    <p className="!text-lg font-normal text-main-normal">
                        {formatMoney(shipmentDetails?.totalAmount - shipmentDetails?.paidAmount)}
                    </p>
                </div>
                <div>
                    <p className="mb-1 text-sm text-main-grey">Total paid</p>
                    <p className="!text-lg font-normal text-main-dark">
                        {formatMoney(shipmentDetails?.paidAmount)}
                    </p>
                </div>
            </div>

            {/* Cost Breakdown */}
            <p className="text-sm font-medium text-main-grey !pt-10 mb-1">Cost breakdown</p>

            <div className="p-6 border border-gray-200 rounded-lg">
                <div className="w-full">
                    <div>
                        {/* Total Shipping Costs */}
                        <div className="flex gap-x-10">
                            <div className="w-4/12 py-1 text-sm text-main-grey">
                                Total shipping costs
                            </div>
                            <div className="py-1 text-base font-semibold text-right text-main-dark">
                                {currencyPairCheck(shipmentDetails?.currency)}
                                {formatMoney(shipmentDetails?.totalAmount)}
                            </div>
                        </div>

                        {/* Breakdown Items */}
                        {paymentDetails?.map((item, index) => (
                            <div className="flex gap-x-10" key={index}>
                                <div className="w-4/12 py-1 pl-4 text-sm text-main-grey">
                                    {item.costType == "clearingFee"
                                        ? "Clearing Fee"
                                        : item?.costType == "truckingFee"
                                        ? "Trucking Fee"
                                        : item?.costType}
                                </div>
                                <div className="py-1 text-lg font-bold text-right text-main-dark">
                                    {currencyPairCheck(shipmentDetails?.currency)}
                                    {formatMoney(item.amount)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentTab;
